import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import ReactNotify from 'react-notify';
import DefinicjaGodzinyStartowejService from "./../DefinicjaGodzinyStartowejService";
import DefinicjaGodzinyStartowejForm from "./../components/DefinicjaGodzinyStartowejForm";
import TrasyService from "../../../trasyConfig/trasy/TrasyService";
import RodzajKalendarzyService from "../../kalendarze/rodzajeKalendarzy/RodzajKalendarzyService";
import DefinicjaGodzinyStartowejTable from "./../components/DefinicjaGodzinyStartowejTable";
import {TopAlertOstrzezenie} from "../../../../../componentsTopsa/alerty/TopAlerts";
import DefinicjaGodzinyStartowejDodawanieForm from "../components/DefinicjaGodzinyStartowejDodawanieForm";
import EkipyService from "../../../zasobyConfig/ekipy/definicjaEkipy/EkipyService";

export default class DGSZdefiniowanieTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            godziny: [],
            trasy: [],
            kalendarze: [],
            parametry: null,
            kalendarz_wybrany: null,
            godzina_wybrana: '',
            validatorMessages: [],
            ekipy:[]
        };

        this.getTrasy = this.getTrasy.bind(this)
        this.getKalendarze = this.getKalendarze.bind(this)
        this.getGodzinyWTrasie = this.getGodzinyWTrasie.bind(this)
        this.getGodzinyWTrasieIwKalendarzu = this.getGodzinyWTrasieIwKalendarzu.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
        this.onDodajNowaGodzina = this.onDodajNowaGodzina.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onEdycjaGodziny = this.onEdycjaGodziny.bind(this)
    }

    componentDidMount() {
        this.getTrasy();
        this.getKalendarze();
        this.getEkipy()
    }

    getEkipy(){
        EkipyService.getEkipy().then(function (response) {
            this.setState({ekipy:response.data.content})
        }.bind(this))
    }

    getTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    getKalendarze() {
        RodzajKalendarzyService.getKalendarze().then(function (response) {
            this.setState({kalendarze: response.data.content})
        }.bind(this))
    }


    getGodzinyWTrasie(idTr) {
        DefinicjaGodzinyStartowejService.getGodzinyWTrasie(idTr).then(function (response) {
            this.setState({godziny: response.data})
        }.bind(this))
    }

    getGodzinyWTrasieIwKalendarzu(idTr, idRk) {
        DefinicjaGodzinyStartowejService.getGodzinyWTrasieIKalendarzu(idTr, idRk).then(function (response) {
            this.setState({godziny: response.data})
        }.bind(this))
    }

    hourToFloat(val){
        return parseFloat((val).replace(':', '.'))
    }

    onClickSzukaj(parametry) {
        this.setState({parametry: parametry});

        if (Boolean(parametry.kalendarz) && parametry.godzina.length > 0) {
            // gdy podane jest wszystko
            DefinicjaGodzinyStartowejService.getGodzinyWTrasieIKalendarzu(parametry.trasa.idTr, parametry.kalendarz.idRk).then(function (response) {
                let rekordy = response.data.filter(r => this.hourToFloat(r.godz1p) >= this.hourToFloat(parametry.godzina))
                this.setState({godziny: rekordy})
            }.bind(this))
        }

        else if (parametry.godzina.length > 0) {
            // gdy podana jest trasa i godzina

            DefinicjaGodzinyStartowejService.getGodzinyWTrasie(parametry.trasa.idTr).then(function (response) {
                let rekordy = response.data.filter(r => this.hourToFloat(r.godz1p) >= this.hourToFloat(parametry.godzina))
                this.setState({godziny: rekordy})
            }.bind(this))

        }
        else if (Boolean(parametry.kalendarz)) {
            // gdy podana jest trasa i kalendarz
            this.getGodzinyWTrasieIwKalendarzu(parametry.trasa.idTr, parametry.kalendarz.idRk)

        }
        else {
            // gdy podana jest tylko trasa
            this.getGodzinyWTrasie(parametry.trasa.idTr);
        }

    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc godzinę: ' + obj.godz1p)) {
            DefinicjaGodzinyStartowejService.deleteGodzina(obj.idTrk).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto godzinę', "", 3000)
                    this.onClickSzukaj(this.state.parametry);
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania godziny', "", 3000)
                }
            }.bind(this))

        }
    }

    onEdycjaGodziny(obj) {
        DefinicjaGodzinyStartowejService.editGodzina(obj.idTrk, obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie edytowano rekord', "", 3000)
                this.onClickSzukaj(this.state.parametry);
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycjii rekordu', "", 3000)
            }
        }.bind(this))
    }

    renderTables() {
        if (Boolean(this.state.parametry)) {

            if (Boolean(this.state.parametry.kalendarz)) {
                // jeden kalendarz - jedna tabela

                return (
                    <div>
                        <h4 style={{marginTop: '25px', textAlign: 'center'}}>
                            <span className={'label label-ebus-primary'} style={{fontSize:'16px'}}>
                            {(this.state.kalendarze.find(k => k.idRk === this.state.parametry.kalendarz.idRk)).nazRk}
                            </span>
                        </h4>
                        <DefinicjaGodzinyStartowejTable data={this.state.godziny} trasy={this.state.trasy}
                                                        kalendarze={this.state.kalendarze}
                                                        handleUsun={this.onClickUsun}
                                                        handleEdycjaGodziny={this.onEdycjaGodziny}
                                                        ekipy={this.state.ekipy}
                        />
                        <DefinicjaGodzinyStartowejDodawanieForm kalendarze={this.state.kalendarze} kalendarzId={this.state.parametry.kalendarz.idRk}
                                                                trasaId={this.state.parametry.trasa.idTr} handleClickDodaj={this.onDodajNowaGodzina}/>
                    </div>
                )
            }
            else {
                if (this.state.godziny.length <= 0) {
                    return (<div>
                        <TopAlertOstrzezenie text={'Do tej trasy nie zdefiniowano jeszcze godzin'}/>
                        <DefinicjaGodzinyStartowejDodawanieForm kalendarze={this.state.kalendarze} kalendarzId={null}
                                                                trasaId={this.state.parametry.trasa.idTr} handleClickDodaj={this.onDodajNowaGodzina}/>
                    </div>)
                }
                else {
                    return this.state.kalendarze.map(kalendarz => {
                        return (
                            <div>
                                {
                                    (this.state.godziny.find(godz => godz.idRk === kalendarz.idRk)) ?
                                        <div>
                                            <h4 style={{marginTop: '25px', textAlign: 'center'}}>
                                                <span className={'label label-ebus-primary'} style={{fontSize:'16px'}}>
                                                {(this.state.kalendarze.find(k => k.idRk === kalendarz.idRk)).nazRk}
                                                </span>
                                            </h4>
                                            <DefinicjaGodzinyStartowejTable data={this.state.godziny.filter(godz => godz.idRk === kalendarz.idRk)}
                                                                            trasy={this.state.trasy}
                                                                            kalendarze={this.state.kalendarze}
                                                                            handleUsun={this.onClickUsun}
                                                                            handleEdycjaGodziny={this.onEdycjaGodziny}
                                                                            ekipy={this.state.ekipy}
                                            />
                                            <DefinicjaGodzinyStartowejDodawanieForm kalendarze={this.state.kalendarze} kalendarzId={kalendarz.idRk}
                                                                                    trasaId={this.state.parametry.trasa.idTr}
                                                                                    handleClickDodaj={this.onDodajNowaGodzina}/>
                                        </div>
                                        :
                                        ''
                                }

                            </div>
                        )
                    })
                }

            }
        }
    }

    onDodajNowaGodzina(obj) {
        DefinicjaGodzinyStartowejService.addGodzina(obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie dodano godzinę', "", 3000)
                this.onClickSzukaj(this.state.parametry)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas dodawania godziny', "", 3000)
            }
        }.bind(this))

    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col sm={12}>
                        <DefinicjaGodzinyStartowejForm trasy={this.state.trasy}
                                                       kalendarze={this.state.kalendarze}
                                                       handleClickSzukaj={this.onClickSzukaj}
                        />
                    </Col>
                    <Col sm={12}>
                        {this.renderTables()}
                    </Col>
                </Row>
                <div style={{height: '15px'}}></div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/DGSZdefiniowanieTab/DGSZdefiniowanieTab.js